import React, { useState } from 'react';
import getReceiptUrl from '../../services/receiptService';
import ReceiptButton from '../receipt/ReceiptButton';
import './ReceiptTester.scss';

/**
 * A component for testing the receipt URL functionality
 * This can be included temporarily in the development environment
 */
function ReceiptTester() {
  const [sessionId, setSessionId] = useState('');
  const [receiptUrl, setReceiptUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showButton, setShowButton] = useState(false);
  
  const handleTestReceipt = async () => {
    if (!sessionId.trim()) {
      setError('Please enter a session ID');
      return;
    }
    
    setLoading(true);
    setError(null);
    setReceiptUrl(null);
    setShowButton(false);
    
    try {
      const url = await getReceiptUrl(sessionId);
      if (url) {
        setReceiptUrl(url);
      } else {
        setError('No receipt URL found for this session ID');
      }
    } catch (err) {
      setError(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleButtonTest = () => {
    setShowButton(true);
  };
  
  // Generate a test session ID for easy testing
  const generateTestId = () => {
    const randomString = Math.random().toString(36).substring(2, 10);
    setSessionId(`cs_test_${randomString}`);
  };
  
  return (
    <div className="receipt-tester">
      <h3>Receipt URL Tester</h3>
      <p className="note">For development purposes only</p>
      
      <div className="input-group">
        <label htmlFor="session-id">Stripe Session ID:</label>
        <div className="input-row">
          <input 
            type="text" 
            id="session-id"
            value={sessionId}
            onChange={(e) => setSessionId(e.target.value)}
            placeholder="cs_test_..."
          />
          <button 
            className="generate-button"
            onClick={generateTestId}
            title="Generate a fake test ID"
          >
            Generate
          </button>
        </div>
        <div className="hint">Enter a Stripe Checkout Session ID starting with cs_test_</div>
      </div>
      
      <div className="button-row">
        <button 
          className="test-button"
          onClick={handleTestReceipt}
          disabled={loading || !sessionId.trim()}
        >
          {loading ? 'Testing...' : 'Test Receipt URL'}
        </button>
        
        <button 
          className="component-button"
          onClick={handleButtonTest}
          disabled={loading || !sessionId.trim()}
        >
          Test Receipt Button Component
        </button>
      </div>
      
      {error && (
        <div className="error-message">{error}</div>
      )}
      
      {receiptUrl && (
        <div className="result-section">
          <p>Receipt URL found:</p>
          <a 
            href={receiptUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="receipt-link"
          >
            {receiptUrl}
          </a>
        </div>
      )}
      
      {showButton && (
        <div className="component-test-section">
          <h4>Receipt Button Component Test</h4>
          <div className="receipt-button-demo">
            <ReceiptButton 
              sessionId={sessionId} 
              buttonText="View Test Receipt"
            />
          </div>
          <div className="code-example">
            <p>Example code:</p>
            <pre>
              {`<ReceiptButton 
  sessionId="${sessionId}" 
  buttonText="View Receipt"
/>`}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReceiptTester; 